import script from "./OpenTickets.vue?vue&type=script&lang=ts&setup=true"
export * from "./OpenTickets.vue?vue&type=script&lang=ts&setup=true"

import "./OpenTickets.vue?vue&type=style&index=0&id=5b3893ee&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5b3893ee"]])

export default __exports__